
<template>
  <div class="text-left">
    <div v-if="componentReady">
      <h5 v-text="t('forms.new_contractor_jurs.IC_0001')"/>
      <hr>

      <div class="panel">
        <p>
          <span v-text="t('forms.new_contractor_jurs.IC_0002')"/>
          <span class="required">*</span>
        </p>
      </div>

      <div class="row">
        <div class="small-12 medium-5 columns">
          <h6 v-text="t('forms.new_contractor_jurs.IC_0003')"/>

          <div>
            <input
              v-model="availableText"
              type="text"
              :placeholder="t('register.filter_jurs')">
          </div>

          <select v-model="regionSelected">
            <option
              value="0"
              v-text="t('register.filter_region')"/>
            <option
              v-for="region in jurInfo.allRegions"
              :value="region.value"
              v-text="region.name"/>
          </select>

          <select
            v-model="jursSelected"
            @dblclick="addToSelected"
            multiple
            size="15">
            <option
              v-for="jurs in availableJurs"
              v-if="jursNotSelected(jurs.value)"
              :value="jurs.value"
              :title="jurs.name"
              v-text="jurs.name"/>
          </select>
        </div>

        <div class="small-12 medium-2 columns text-center show-for-medium-up">
          <div>
            <div style="top: 220px; position: relative;">
              <a
                class="fa fa-angle-double-left fa-2x grow"
                @click="removeFromSelected"/>
              <a
                class="fa fa-angle-double-right fa-2x grow"
                @click="addToSelected"/>
            </div>
          </div>
        </div>

        <div class="small-12 medium-2 columns text-center show-for-small-only">
          <div>
            <div style="position: relative;">
              <a
                class="fa fa-angle-double-up fa-2x grow"
                @click="removeFromSelected"/>
              <a
                class="fa fa-angle-double-down fa-2x grow"
                @click="addToSelected"/>
            </div>
          </div>
        </div>

        <div class="small-12 medium-5 columns">
          <h6 v-text="t('forms.new_contractor_services.IC_0004')"/>

          <div>
            <input
              v-model="selectedText"
              type="text"
              :placeholder="t('register.filter_jurs')">
          </div>

          <select
            v-model="jursCurrent"
            multiple
            @dblclick="removeFromSelected"
            size="15"
            style="margin-top: 45px;">
            <option
              v-for="jurs in currentJurs"
              :value="jurs.value"
              :title="jurs.name"
              v-text="jurs.name"/>
          </select>
        </div>
      </div>

      <div class="row" style="margin-top: 30px;">
        <div class="columns large-3">
          <button
            class="tiny radius expand"
            @click="$emit('tab-change', 2)"
            v-text="t('courses.modal_previous')"/>
        </div>
        <div class="columns large-1">
          &nbsp;
        </div>
        <div class="columns large-4">
          <button
            @click="openGuide"
            class="tiny radius expand"
            v-text="t('register.user_guide')"/>
        </div>
        <div class="columns large-1">
          &nbsp;
        </div>
        <div class="columns large-3">
          <button
            class="tiny radius expand"
            @click="nexStep"
            v-text="t('member_basic_edit.IC_0013')"/>
        </div>
      </div>
    </div>

    <div v-if="!componentReady">
      <i class="fa fa-spinner fa-spin fa-2x"/>
    </div>

  </div>

</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {

  props: ['displayData'],

  data() {
    return {
      localData: {},
      jurInfo: {},
      originalJurInfo: {},
      componentReady: false,
      regionSelected: '0',
      jursSelected: [],
      jursCurrent: [],
      availableText: '',
      selectedText: '',
      currentJurs: [],
    };
  },

  computed: {
    availableJurs() {
      if (this.regionSelected === '0') {
        return this.jurInfo.allJurs;
      }

      return _.filter(this.jurInfo.allJurs, ({ CountryID }) => CountryID === this.regionSelected);
    },
  },

  watch: {
    'jurInfo.currentJurs': {
      deep: true,
      handler: function(val) {
        this.currentJurs = _.filter(this.originalJurInfo.allJurs, ({ value }) =>
          _.includes(this.jurInfo.currentJurs, value));
      }
    },

    availableText(val) {
      this.jurInfo.allJurs = _.filter(_.cloneDeep(this.originalJurInfo.allJurs), ({ name }) =>
        _.includes(_.toLower(_.trim(name)), _.toLower(_.trim(val))));

      if (_.size(val) === 0) {
        this.jurInfo.allJurs = _.cloneDeep(this.originalJurInfo.allJurs);
      }
    },

    selectedText(val) {
      const match =  _.filter(_.cloneDeep(this.originalJurInfo.allJurs), ({ name }) =>
        _.includes(_.toLower(_.trim(name)), _.toLower(_.trim(val))));

      const matchIds = _.map(match, ({ value }) => value);

      this.jurInfo.currentJurs = _.filter(_.cloneDeep(this.originalJurInfo.currentJurs), id =>
        _.includes(matchIds, id));

      if (_.size(val) === 0) {
        this.jurInfo.currentJurs = _.cloneDeep(this.originalJurInfo.currentJurs);
      }
    },
  },

  beforeMount() {
    this.localData = _.cloneDeep(this.displayData);

    $.post('/register/tab-data/jurisdications', (data) => {
      this.jurInfo = data;
      this.originalJurInfo = _.cloneDeep(data);
      this.componentReady = true;
    }).fail( () => {
      window.location.href = '/register';
    });
  },

  methods: {
    openGuide() {
      window.open(t('register.user_guide_link'), '_blank')
    },

    nexStep() {
      if (_.isEmpty(this.currentJurs)) {
        toastr.error(t('forms.new_contractor_jurs.IC_0002'));
      } else {
        this.$emit('display-change', this.localData);
        this.$emit('complete', true);
      }
    },

    saveJurisdiction() {
      const newJurs = this.jurInfo.currentJurs.join(',');

      this.localData.memberInfo.Jurisdictions = newJurs;

      $.post('/register/save-company', {
        memberInfo: this.localData.memberInfo,
      });
    },

    removeFromSelected() {
      _.forEach(this.jursCurrent, (idSelected) => {
        this.originalJurInfo.currentJurs =
          _.filter(this.originalJurInfo.currentJurs, id => id !== idSelected);
        this.jurInfo.currentJurs = _.filter(this.jurInfo.currentJurs, id => id !== idSelected);
      });

      this.saveJurisdiction();
    },

    addToSelected() {
      _.forEach(this.jursSelected, (id) => {
        this.originalJurInfo.currentJurs.push(id);
        this.jurInfo.currentJurs.push(id);
      });

      this.saveJurisdiction();
    },

    jursNotSelected(jursId) {
      return !_.includes(this.originalJurInfo.currentJurs, jursId);
    },
  },
};
</script>
<style scoped>
.grow:hover {
  -webkit-transform: scale(1.3);
  -ms-transform: scale(1.3);
  transform: scale(1.3);
}
</style>
